module.exports = __webpack_public_path__ + "static/media/Footerlogo.afcdaf20.svg";